module.exports = __webpack_public_path__ + "static/media/plus.61478bc6.png";